module.exports = __webpack_public_path__ + "static/media/rantangan.37b33a7e.jpg";